import React, { useEffect, useRef } from "react";
import { Box, useColorModeValue } from "@chakra-ui/react";
import LandingHero from "./LandingHero";
import LandingSparkSection from "./LandingSparkSection";
import LandingDealSection from "./LandingDealSection";
import LandingInboxSection from "./LandingInboxSection";
import LandingReportsSection from "./LandingReportsSection";
import LandingFooter from "./LandingFooter";

const LandingPage = () => {
  // Create refs for sections
  const heroRef = useRef(null);
  const footerRef = useRef(null);

  // Add global styles for animation control
  useEffect(() => {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = `
      /* Animation control classes */
      .animation-paused .animated-line,
      .animation-paused [class*='animate'],
      .animation-paused [style*='animation'],
      .animation-paused .rotating-icon {
        animation: none !important;
        transition: none !important;
      }

      /* Keyframes definitions for common animations can be added here too */
      @keyframes flowDownAnimation {
        0% { stroke-dashoffset: 0; }
        100% { stroke-dashoffset: -20; }
      }
      
      @keyframes rotate {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
      
      @keyframes pulse {
        0% { transform: scale(1); }
        50% { transform: scale(1.05); }
        100% { transform: scale(1); }
      }
    `;
    document.head.appendChild(styleTag);
    
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  // Function to scroll to top of page
  const scrollToPageTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Effect to handle scrolling when coming from legal pages
  useEffect(() => {
    
    // Check for the scrollToTop flag first (priority)
    const scrollToTop = localStorage.getItem("scrollToTop");
    if (scrollToTop) {
      localStorage.removeItem("scrollToTop");
      
      // Use small timeout to ensure page is rendered
      setTimeout(() => {
        scrollToPageTop();
      }, 100);
      
      return; // Exit early since we've handled scrolling
    }
    
    // Check for section scroll flag (for footer links)
    const scrollToSection = localStorage.getItem("scrollToSection");
    if (scrollToSection) {
      // Clear localStorage
      localStorage.removeItem("scrollToSection");
      
      // Scroll after a slight delay to ensure component is mounted
      setTimeout(() => {
        const footerElement = document.getElementById("landing-footer");
        
        if (scrollToSection === "privacy" && footerElement) {
          const privacyLink = footerElement.querySelector('a[href*="privacy"]');
          if (privacyLink) {
            privacyLink.scrollIntoView({ behavior: "smooth" });
          }
        } else if (scrollToSection === "terms" && footerElement) {
          const termsLink = footerElement.querySelector('a[href*="terms"]');
          if (termsLink) {
            termsLink.scrollIntoView({ behavior: "smooth" });
          }
        }
      }, 300);
    }
    
    // Check sessionStorage backup method
    const cameFromLegal = sessionStorage.getItem("cameFromLegal");
    if (cameFromLegal) {
      sessionStorage.removeItem("cameFromLegal");
      
      if (cameFromLegal === "top") {
        setTimeout(() => {
          scrollToPageTop();
        }, 100);
      }
    }
  }, []);

  return (
    <Box bg={useColorModeValue("white", "gray.900")}>
      <Box ref={heroRef} id="hero-section">
        <LandingHero />
      </Box>
      <Box id="spark-section">
        <LandingSparkSection />
      </Box>
      <Box id="deal-section">
        <LandingDealSection />
      </Box>
      <Box id="inbox-section">
        <LandingInboxSection />
      </Box>
      <Box id="reports-section">
        <LandingReportsSection />
      </Box>
      <Box id="landing-footer" ref={footerRef}>
        <LandingFooter />
      </Box>
    </Box>
  );
};

export default LandingPage; 